import React from "react";
import { Grid, Typography, Divider } from "@material-ui/core";
import FilterChip from "./FilterChip";

const FilterRow = ({
    title,
    filterName,
    filters,
    selectedFilters,
    onChange,
    toggleFilter,
    getIcon,
    getLabel,
}) => {
    return (
        <>
            <Grid item xs={12} style={{ paddingTop: 8, paddingBottom: 8 }}>
                <Grid
                    container
                    alignItems="center"
                    spacing={2}
                    wrap="nowrap"
                >
                    <Grid item style={{ width: 130 }}>
                        <Typography
                            variant="subtitle2"
                            style={{
                                color: "#616161",
                                margin: 0,
                                lineHeight: 1.2
                            }}
                        >
                            {title}
                        </Typography>
                    </Grid>

                    <Grid item xs>
                        <Grid container spacing={1}>
                            {filters.map((filter) => (
                                <Grid item key={filter.value}>
                                    <FilterChip
                                        filter={filter}
                                        filters={selectedFilters}
                                        filterName={filterName}
                                        onChange={onChange}
                                        toggleFilter={toggleFilter}
                                        icon={getIcon(filter)}
                                        label={getLabel(filter)}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid item xs={12} style={{ paddingTop: 4, paddingBottom: 4 }}>
                <Divider />
            </Grid>
        </>
    );
};

export default FilterRow;